<template>
    <multiselect v-model="model"
                 :track-by="trackBy"
                 :placeholder="placeholder"
                 open-direction="bottom"
                 :options="options"
                 :searchable="true"
                 :loading="loading"
                 :internal-search="false"
                 :clear-on-select="false"
                 :close-on-select="true"
                 :options-limit="300"
                 :max-height="600"
                 :show-no-results="false"
                 :hide-selected="false"
                 @search-change="timerSearch"
                 @remove="$emit('remove', $event)"
                 :show-no-options="false"
                 :multiple="multiple"
                 :selectedLabel="$t('selectAsync.selected')"
                 :label="label"
                 :class="{ 'border border-danger': hasError }"
                 ref="multiselect"
    >
        <template slot="option" slot-scope="props">
            <slot name="option" v-bind:option="props.option"></slot>
        </template>
        <template slot="singleLabel" slot-scope="props">
            <slot name="singleLabel" v-bind:option="props.option"></slot>
        </template>
        <template slot="tag" slot-scope="props">
            <slot name="tag" v-bind:option="props.option"></slot>
        </template>
        <template v-slot:no-options>NO</template>
    </multiselect>
</template>

<script>
    import multiselect from 'vue-multiselect'

    export default {
        props: {
            'value': [ Number, Array, Object, String ],
            'trackBy': {
                type: String,
                default: 'id'
            },
            'placeholder': {
                type: String,
                default: 'Type to search'
            },
            'searchFunction': {
                type: Function,
                required: true
            },
            'hasError': Boolean,
            'multiple': Boolean,
            'label': String
        },
        data() {
            return {
                timingSearch: '',
                loading: false,
                options: [],
                model: this.value
            }
        },
        methods: {
            timerSearch(search) {
                clearInterval(this.timingSearch);
                this.timingSearch = setInterval(() => {
                    this.fetchData(search);
                }, 400);
            },
            fetchData(search) {
                clearInterval(this.timingSearch);
                if (search) {
                    this.loading = true
                    this.searchFunction(search).then((response) => {
                        this.options = response.data
                    }).finally(() => {
                        this.loading = false
                    })
                }
                else {
                    this.options = []
                }
            }
        },
        components: {
            multiselect
        },
        watch: {
            'model': {
                immediate: true,
                handler: function(val) {
                    if (val) {
                        if (this.isArray) {
                            const ids = this.$options.filters.pluck(val, this.trackBy)
                            this.$emit('input', ids)
                        }
                        else {
                            this.$emit('input', val[this.trackBy])
                        }
                    }
                }
            }
        },
        computed: {
            isArray: function() {
                return Array.isArray(this.value)
            }
        }
    }
</script>